import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  activeRecordingIcon: {
    boxShadow: '0 0 0 0 rgba(213, 15, 45, 1)',
    animation: 'pulse-red 2s infinite',
    borderRadius: '100%',
  },
}));
